"use client";
import { Box, Flex, Heading } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { SectionTemplate } from "components/individuals/blocks";
import { customRichText } from "components/individuals/mdx-components";
import { ImageFragment } from "lib/gcms";

export interface KeyFeaturesSectionProps {
  title: string;
  content: any;
  bg: string;
  textColor: string;
}

export const KeyFeaturesSection = ({
  title,
  content,
  bg,
  textColor,
}: KeyFeaturesSectionProps) => {
  return (
    <SectionTemplate bg={bg} color={textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        mb={{
          base: 6,
          lg: 8,
        }}
        fontWeight={"bold"}
      >
        {title}
      </Heading>
      <Flex gap={{ base: 10, md: 20 }} flexDir={{ base: "column", md: "row" }}>
        <Box flex="1" minW={0}>
          <RichText
            content={content.raw}
            renderers={customRichText(textColor, undefined, undefined, {
              base: 16,
              md: 20,
              xl: 22,
            })}
          />
        </Box>
        <Box flex="1" minW={0} w={"80%"} mx={"auto"}>
          <Box
            position="relative"
            w="full"
            pt="56.25%"
            borderRadius="xl"
            overflow="hidden"
          >
            <iframe
              src="https://www.youtube.com/embed/_UgpyVAn9ao?si=1saFGgZy82u53RhR"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
            />
          </Box>
        </Box>
      </Flex>
    </SectionTemplate>
  );
};
